import { render } from "./TeamsList.vue?vue&type=template&id=3070da1c"
import script from "./TeamsList.vue?vue&type=script&lang=js"
export * from "./TeamsList.vue?vue&type=script&lang=js"
script.render = render

export default script